/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { dashboardServices } from "../../../../service/dashboard";
import translationData from '../../../../locales/dashboardTranslation.json'
import { LuActivity, LuAlertTriangle, LuArchive, LuCheckCircle2, LuClock, LuLayers, LuRotateCcw } from "react-icons/lu";
import { InventoryHealthBar, KpiCardNew, SectionHeaderNew } from "./KpiCardNew";

interface Column {
  id: number;
  content: string;
  count: number;
}

interface ExceptionDetailsLayoutProps {
  heading: string;
  selectedDate: any;
}

const columnStyle = {
  margin: "0 0 6px 0",
};

const lastColumnStyle = {
  margin: "0",
};

const InventryDetailsLayout: React.FC<ExceptionDetailsLayoutProps> = ({
  heading,
  selectedDate,
}) => {
  const navigate = useNavigate();

  interface ColumnData {
    id: number;
    apiName: string;
    displayName: string;
    count: number;
    isBlinking?: boolean;
  }
  
  const [columnsData, setColumnsData] = useState<ColumnData[]>([]);
  const [highlightBlink, setHighlightBlink] = useState(false);
  const [alertStat, setAlertStat] = useState(null);
  const [inventoryStats, setInventoryStats] = useState<any>(null);
  const navigateToOtherPage = () => {
    // navigate('/exposure-table'); 
  };

  const switchToPage = (id: number) => {
    if(id >= 1 && id <= 2) {
        // navigate(`/inner-view-descrepency/${id}`);
    }
  }

 //api call to get the discrepency stat values 
  const getDescrepancyStatus = async () => {
    try {
      const response = await dashboardServices.getInventoryStatus(selectedDate);
      console.log(response, "12123")
      if (response.status && response.statusCode === 200) {
        try {
          const responseData = response.data;
          if (responseData) {
            const alertStat = responseData.alert_stat;
            setAlertStat(alertStat);
            const usedPlates = Number(responseData.used_plates || 0);
            const remainingPlates = Number(responseData.remaining_plates || 0);
            const totalPlates = Number(responseData.total_plates || 0);

            const usedPercentage =
              totalPlates > 0
                ? Math.round((usedPlates / totalPlates) * 100)
                : 0;

            const remainingPercentage =
              totalPlates > 0
                ? Math.round((remainingPlates / totalPlates) * 100)
                : 0;

            setInventoryStats({
              used: usedPercentage,
              remaining: remainingPercentage,
            });


            setColumnsData(prevColumnsData => {
              return prevColumnsData.map(column => {
                const { apiName, displayName } = column;
                console.log(apiName, displayName , "12123")

                const apiCount = responseData[apiName];
                console.log(apiCount, "12123")


                if (apiCount !== undefined) {
                  return { ...column, count: apiCount };
                } else {
                  console.warn(`API response for ${displayName} is undefined or missing.`);
                  return column;
                }
              });
            });

            if (alertStat === "1") {
              setHighlightBlink(true);
            } else {
              setHighlightBlink(false);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('user response', error);
    }
  };
  
  useEffect(() => {
    const DiscrepancyHead = translationData.InventoryHead;
    setColumnsData(DiscrepancyHead.map((item => ({ ...item, count: 0 }))));
    }, []); 

  //api call when change in selected date 
  useEffect(() => {
    getDescrepancyStatus();
  }, [])

  //blinking effect based on the alert status key 
  useEffect(() => {
    // Start blinking when alert_stat is 1
    if (alertStat === 1) {
      const blinkInterval = setInterval(() => {
        setHighlightBlink(prevState => !prevState);
      }, 1000);

      return () => {
        clearInterval(blinkInterval);
      };
    } else {
      
      setHighlightBlink(false);
    }
  }, [alertStat]);

  //highlight the coloumn in stat values
  const getColumnNameStyle = (column: any) => {
    if (column.displayName.includes('Pending Exceptions') && highlightBlink) {
      return `highlight ${highlightBlink ? 'blink' : ''} column-style redText`;
    } else if (column.displayName === 'Pending Exceptions') {
      return 'column-style yellowText';
    } else {
      return 'column-style';
    }
  };

  const getIcon = (name : any) => {
    switch (name) {
      case "Total Batches":
        return LuLayers;
      case "Total Plates":
        return LuArchive;
      case "Used Plates":
        return LuCheckCircle2;
      case "Remaining Plates":
        return LuRotateCcw;
    }
  };

return (
    <div className="flex flex-col pe-4">
  <SectionHeaderNew
    title={heading}
    onClick={navigateToOtherPage}
  />

  <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-stretch">
    {/* KPI Cards */}
    <div className="md:col-span-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 h-full">
        {columnsData.map((column) => (
          <div
            key={column.id}
            onClick={() => switchToPage(column.id)}
            className="cursor-pointer h-[160px]"
          >
            <KpiCardNew
              label={column.displayName}
              val={column.count}
              icon={getIcon(column.displayName)}
              color={
                column.displayName === "Pending Exceptions"
                  ? "red"
                  : "blue"
              }
              layout="horizontal"
              className="h-full"
            />
          </div>
        ))}
      </div>
    </div>

    {/* Inventory Health */}
    <div className="md:col-span-4 h-[160px]">
      <InventoryHealthBar
        used={inventoryStats?.used}
        remaining={inventoryStats?.remaining}
      />
    </div>
  </div>
</div>
);
};

export default InventryDetailsLayout;
